import { Column } from 'src/shared/components/Semantic/all'
import { ProductGrid } from 'src/shared/components/ProductGrid'
import { PaginationComponent } from './PaginationComponent'
import { ProductQueryResult } from '../types'

export const ProductGridSection = ({
  product_items,
  activeResult,
  page,
  pageSize,
  currentTotalPages,
  onPageChange,
  onPageSizeChange,
  addToCurrentQuoteId,
  embedUseProductPreview = false,
  showAddToQuote = true,
}: {
  product_items?: {
    product_id?: number
    product_variant_color_id?: number
    relevance_score?: number
  }[]
  activeResult?: ProductQueryResult
  page: number
  pageSize: number
  currentTotalPages: number
  onPageChange: (newPage: number) => void
  onPageSizeChange: (newPageSize: number) => void
  addToCurrentQuoteId?: number
  /** Product cards open preview modal instead of navigating (e.g. embedded catalog panel). */
  embedUseProductPreview?: boolean
  showAddToQuote?: boolean
}) => {
  if (!product_items || product_items.length === 0) return null

  return (
    <Column className="gap-4">
      <ProductGrid
        product_items={product_items}
        scrollArea={false}
        addToCurrentQuoteId={addToCurrentQuoteId}
        isChat={embedUseProductPreview}
        showAddToQuote={showAddToQuote}
      />

      <PaginationComponent
        activeResult={
          activeResult
            ? {
                count: activeResult.count,
                totalPages: activeResult.totalPages,
              }
            : null
        }
        page={page}
        pageSize={pageSize}
        currentTotalPages={currentTotalPages}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </Column>
  )
}
